// Constants
const IS_DEV = false
const USE_STICKY_CSS = true
const CustomEvents = {
    stickyFilterBox: 'custom:stickyFilterBox'
}

// Functions
const handleFilterGroup = ( filterGroup ) => {
    const filterBreakpoint = filterGroup.querySelector('.filter-breakpoint')
    const filterBox = document.querySelector('.filters--container')
    if ( !!!filterBreakpoint ) return
    if ( filterBreakpoint.classList.contains('custom--initialized') ) return
    
    const isAlgoliaItem = filterBreakpoint.closest('.ais-page')

    const initializedItem = filterBreakpoint.closest('.ais-RefinementList-list').querySelector('.filter-breakpoint.custom--initialized')

    if ( !!initializedItem ) {
        const oldCollapsibleContainer = filterGroup.querySelector('.collection__filter-custom--collapsible')
        initializedItem.remove()
        oldCollapsibleContainer && oldCollapsibleContainer.remove()
    }
    
    const previousFilter = isAlgoliaItem 
        ? filterBreakpoint.parentElement.parentElement.previousElementSibling
        : filterBreakpoint.previousElementSibling
    
    const [...outsiderFilters] = filterGroup.querySelectorAll('.filter--hide')
    const collapsible = document.createElement('div')
    collapsible.classList.add('collection__filter-custom--collapsible')
    collapsible.style.height = 0
    collapsible.style.overflow = 'hidden'
    collapsible.style.transition = '200ms ease-in-out'
    outsiderFilters.forEach( filter => collapsible.appendChild( filter ) )

    if ( isAlgoliaItem ) {
        filterBreakpoint.parentElement.parentElement.before(filterBreakpoint)
    }

    filterBreakpoint.addEventListener('click', () => {
        const isOpen = filterBreakpoint.dataset.ariaExpanded === 'true'
        filterBreakpoint.dataset.ariaExpanded = isOpen ? 'false' : 'true'
        collapsible.style.height = !isOpen ? `${collapsible.scrollHeight}px` : 0
        collapsible.style.overflow = !isOpen ? 'visible' : 'hidden'
        filterBreakpoint.children[0].textContent = !isOpen ? 'View less...' : 'View all...'
        if ( isOpen ) previousFilter.after(filterBreakpoint)
        else filterGroup.appendChild(filterBreakpoint)

        if ( !USE_STICKY_CSS ) {
            const lastBoxTop = Number(filterBox.style.top.replace(/(px)/, ''))
            
            filterBox.style.transition = '200ms ease-in-out'
            setTimeout(() => {
                filterBox.style.top = isOpen 
                    ? `${lastBoxTop + collapsible.scrollHeight}px`
                    : `${lastBoxTop - collapsible.scrollHeight}px`
            }, 50)
            setTimeout(() => { filterBox.style.transition = 'unset' }, 250)
        }
    })

    filterBreakpoint.after(collapsible)
    filterBreakpoint.classList.add('custom--initialized')
}

const selectCollectionLayout = () => {
    if ( IS_DEV ) return document.dispatchEvent( new Event(CustomEvents.stickyFilterBox) )

    const facetsContainer = document.querySelector('.ais-facets')
    const algoliaPage = document.querySelector('.ais-page')
    if ( !!!facetsContainer && !!algoliaPage ) {
        algoliaPage.parentElement.parentElement.remove()
        document.dispatchEvent( new Event(CustomEvents.stickyFilterBox) )
        return
    }

    if ( !!!algoliaPage ) return document.dispatchEvent( new Event(CustomEvents.stickyFilterBox) )
    
    const collectionNative = document.querySelector('[data-section-type="collection"]')
    collectionNative.remove()
    algoliaPage.classList.remove('u-hidden')
    document.dispatchEvent( new Event(CustomEvents.stickyFilterBox) )
}


// Listeners
document.addEventListener(CustomEvents.stickyFilterBox, () => {
    if ( window.innerWidth <= 480 ) return

    const CUSTOM_MARGIN_PX = 15
    const filtersContainer = document.querySelector('.filters--container')
    if ( !!!filtersContainer ) return

    const productsContainer = filtersContainer.nextElementSibling
    const headerHeight = document.getElementById('shopify-section-header').getBoundingClientRect().height
    const filtersTop = filtersContainer.offsetTop
    let productsContainerHeight = productsContainer.scrollHeight
    let maxSticky = 0
    const threshold = filtersTop - headerHeight - CUSTOM_MARGIN_PX

    if ( !USE_STICKY_CSS ) {
        filtersContainer.style.position = 'relative'
        
        window.addEventListener('scroll', (evt) => {
            productsContainerHeight = productsContainer.scrollHeight
            maxSticky = productsContainerHeight - filtersContainer.getBoundingClientRect().height
            let delta = -(threshold - window.scrollY)
            filtersContainer.style.top = ( window.scrollY >= threshold ) ? `${(delta > maxSticky ? maxSticky : delta)}px` : '0'
        })

        filtersContainer.addEventListener('click', (evt) => {
            if ( !!evt.target.closest('.collection__filter-group-name') ) {
                const btnGroup = evt.target.closest('.collection__filter-group-name')
                const lastBoxTop = Number(filtersContainer.style.top.replace(/(px)/, ''))
                const contentBox = evt.target.closest('.collection__filter-group').querySelector('.collection__filter-collapsible')            
                const isOpen = btnGroup.getAttribute('aria-expanded') === 'true'
    
                if ( Math.floor(lastBoxTop) === Math.floor(maxSticky) ) {
                    filtersContainer.style.transition = '200ms ease-in-out'
                    setTimeout(() => {
                        filtersContainer.style.top = isOpen 
                            ? `${lastBoxTop + contentBox.scrollHeight}px`
                            : `${lastBoxTop - contentBox.scrollHeight}px`
                    }, 50)
                    setTimeout(() => {
                        filtersContainer.style.transition = 'unset'
                        window.dispatchEvent( new Event('scroll') )
                    }, 250)
                }
            }
        })

        window.dispatchEvent( new Event('scroll') )
    }
})

window.addEventListener('custom:checkFiltersCollapibles', () => {
    const [...filterGroups] = document.querySelectorAll('.collection__filter-checkbox-list')
    const [...algoliaFilterGroups] = document.querySelectorAll('.ais-RefinementList.ais-facet > ul')

    ;[...filterGroups, ...algoliaFilterGroups].forEach(handleFilterGroup)
})

document.addEventListener('DOMContentLoaded', () => {
    selectCollectionLayout()

    let waitForCollapsibles = setInterval(() => {
        if ( document.querySelector('.filter-breakpoint') ) {
            window.dispatchEvent( new Event('custom:checkFiltersCollapibles') )
            clearInterval(waitForCollapsibles)
        }
    }, 250)
})